import React, { useState, useEffect } from "react";
import CollapseDivWrapper from "../Components/CollapseableDiv";
import Form from "react-bootstrap/Form";

import styled from "styled-components";
import ColorsSelect from "../Components/ColorsSelect";

import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import {
  setGripper,
  setSplitTorso,
  setPocket,
  SetContrastStiching,
  SetIsCellPhoneZipperPocket,
  setdownloadImageSrc,
  setglobalCanvas,
  setSizingFit,
  setSizingSize,
  setIsLoading,
} from "../redux/Slices/MainSlice";

import Button from "react-bootstrap/Button";
import PatternSelect from "../Components/PatternSelect";
import {
  CELL_PHONE_POCKET,
  GRIPPER_PRICE,
  MAIN_PRICE,
  ORIGINAL_PRODUCT_ID,
  PATTERN_PRICE,
  RDS_POCKET_PRICE,
  REACT_APP_BASE_URL,
  WC_BASIC_AUTH,
} from "../Constants";

import { fabric } from "fabric";
import ColorsList, { patternOptions } from "../Common";
import { SendDesignViaMail } from "./SavedDesingList";


const bodyParts = ["Area 1", "Area 2", "Area 3"];

const OptionsWrapper = styled.div`
& .d-flex:nth-of-type(odd):not(span){
    background-color rgba(0,0,0,0.05);
}
`;



function LeftSide() {
  let dispatch = useDispatch();

  let ColorFiller = useSelector((state) => state.auth.SuitPartsList);
  let grippper = useSelector((state) => state.auth.IsGripper);
  let pocket = useSelector((state) => state.auth.IsPocket);
  let contrastStiching = useSelector((state) => state.auth.IsContrastStiching);
  let IsCellPhoneZipperPocket = useSelector(
    (state) => state.auth.IsCellPhoneZipperPocket
  );

  let splitTorso = useSelector((state) => state.auth.IsSplitTorso);

  const [IsGripper, setIsGripper] = useState(grippper);
  const [IsPoscket, setIsPocket] = useState(pocket);
  const [IsContrastStiching, setIsContrastStiching] =
    useState(contrastStiching);
  const [IsSplitTorso, setIsSplitTorso] = useState(splitTorso);

  const [checkPatternArea, setCheckPatternArea] = useState("");
  const [checkColorv2, setCheckColorv2] = useState("");
  const [checkColorv3, setCheckColorv3] = useState("");


  const SetSplitTorso = (v) => {
    debugger;
    setIsSplitTorso(v);
    dispatch(setSplitTorso(v));
  };
  const SetGripper = (v) => {
    setIsGripper(v);
    dispatch(setGripper(v));
  };
  const SetContrastSticht = (v) => {
    setIsContrastStiching(v);
    dispatch(SetContrastStiching(v));
  };
  const SetPocket = (v) => {
    setIsPocket(v);
    dispatch(setPocket(v));
  };


  return (
    <div className="p-3">
      <div className="mb-3">
        <CollapseDivWrapper open={true} title="Suit Options">
          <div className="d-flex align-items-center">
            <span className="col-6 col-md-4 col-lg-6  flex-sm-grow-0 flex-grow-1 text-start">
              Split Torso
            </span>
            <div className="d-flex align-items-center ">
              <Form.Check
                inline
                type="radio"
                value="no"
                name="IsSplitTorso"
                id="IsSplitTorso2"
                label="No"
                checked={IsSplitTorso === "no" ? true : false}
                onClick={(e) => {
                  SetSplitTorso(e.target.value);
                }}
              />
              <Form.Check
                inline
                type="radio"
                value="yes"
                name="IsSplitTorso"
                id="IsSplitTorso1"
                label="Yes"
                checked={IsSplitTorso === "yes" ? true : false}
                onClick={(e) => {
                  SetSplitTorso(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="d-flex align-items-center">
            <span className="col-6 col-md-4 col-lg-6  flex-sm-grow-0 flex-grow-1 text-start">
              Grippers (+$50)
            </span>
            <div className="d-flex align-items-center ">
              <Form.Check
                inline
                label="No"
                value="no"
                name="group111"
                type="radio"
                checked={IsGripper === "no" ? true : false}
                id={`inline-radio-1`}
                onClick={(e) => {
                  SetGripper(e.target.value);
                }}
              />
              <Form.Check
                inline
                label="Yes"
                value="yes"
                name="group111"
                type="radio"
                checked={IsGripper === "yes" ? true : false}
                id={`inline-radio-2`}
                onClick={(e) => {
                  SetGripper(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="d-flex align-items-center">
            <span className="col-6 col-md-4 col-lg-6   flex-sm-grow-0 flex-grow-1 text-start">
              RDS Pocket (+$45)
            </span>
            <div className="d-flex align-items-center ">
              <Form.Check
                inline
                label="No"
                value="no"
                name="Poscket"
                type="radio"
                checked={IsPoscket === "no" ? true : false}
                id={`inline-radio-3`}
                onClick={(e) => {
                  SetPocket(e.target.value);
                }}
              />
              <Form.Check
                inline
                label="Yes"
                value="yes"
                name="Poscket"
                type="radio"
                checked={IsPoscket === "yes" ? true : false}
                id={`inline-radio-4`}
                onClick={(e) => {
                  SetPocket(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="d-flex align-items-center">
            <span className="col-6 col-md-4 col-lg-6  flex-sm-grow-0 flex-grow-1 text-start">
              {" "}
              Contrast Stiching{" "}
            </span>

            <div className="d-flex align-items-center ">
              <Form.Check
                inline
                label="No"
                value="no"
                name="ContrastStiching"
                type="radio"
                checked={IsContrastStiching === "no" ? true : false}
                id={`ContrastStichingNo`}
                onClick={(e) => {
                  SetContrastSticht(e.target.value);
                }}
              />
              <Form.Check
                inline
                label="Yes"
                value="yes"
                name="ContrastStiching"
                type="radio"
                checked={IsContrastStiching === "yes" ? true : false}
                id={`ContrastStichingYes`}
                onClick={(e) => {
                  SetContrastSticht(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="d-flex align-items-center">
            <span className="col-6 col-md-4 col-lg-6  flex-sm-grow-0 flex-grow-1 text-start">
              Cell Phone Pocket (+$30){" "}
            </span>

            <div className="d-flex align-items-center ">
              <Form.Check
                inline
                label="No"
                value="no"
                name="IsCellPhoneZipperPocket"
                type="radio"
                checked={IsCellPhoneZipperPocket === "no" ? true : false}
                id={`IsCellPhoneZipperPocketNo`}
                onClick={(e) => {
                  dispatch(SetIsCellPhoneZipperPocket(e.target.value));
                }}
              />
              <Form.Check
                inline
                label="Yes"
                value="yes"
                name="IsCellPhoneZipperPocket"
                type="radio"
                checked={IsCellPhoneZipperPocket === "yes" ? true : false}
                id={`IsCellPhoneZipperPocketYes`}
                onClick={(e) => {
                  dispatch(SetIsCellPhoneZipperPocket(e.target.value));
                }}
              />
            </div>
          </div>
        </CollapseDivWrapper>
      </div>
      <CollapseDivWrapper title="Suit Colors">
        <h6 className="fw-bold">Colors and Patterns</h6>
        <p>Select the colors and patterns to customize your suit</p>
        <OptionsWrapper className="OptionsWrapper">
          {bodyParts.map((x) => (
            <div className="d-flex row p-2">
              <div className="col-3 col-sm-2 text-start">{x}</div>
              <div className="col-9 col-sm-10">
                {
                  x === "Area 1" ? (
                    <div className="row">
                      {" "}
                      <div className="  col-12 col-sm-6">
                        {" "}
                        <ColorsSelect
                          selectedColor={
                            ColorFiller.find((i) => i.key === "v1")?.value
                          }
                          type={"v1"}
                        />
                      </div>
                    </div>
                  ) : x === "Area 2" ? (
                    <div className="row">
                      <div className=" col-12 col-sm-6 mb-2 mb-sm-0">
                        <ColorsSelect
                          checkColor={setCheckColorv2}
                          disabled={
                            checkPatternArea === "v2" && checkPatternArea !== ""
                              ? true
                              : false
                          }
                          selectedColor={
                            ColorFiller.find((i) => i.key === "v2")?.value
                          }
                          type={"v2"}
                        />{" "}
                      </div>
                      <div className=" col-12 col-sm-6 mb-2 mb-sm-0">
                        <PatternSelect
                          areaType={"v2"}
                          changeArea={setCheckPatternArea}
                          disabled={
                            (checkPatternArea !== "v2" &&
                              checkPatternArea !== "") ||
                            checkColorv2 !== ""
                              ? true
                              : false
                          }
                        />{" "}
                      </div>
                    </div>
                  ) : x === "Area 3" ? (
                    <div className="row">
                      <div className=" col-12 col-sm-6 mb-2 mb-sm-0">
                        {" "}
                        <ColorsSelect
                          checkColor={setCheckColorv3}
                          disabled={
                            checkPatternArea === "v3" && checkPatternArea !== ""
                              ? true
                              : false
                          }
                          selectedColor={
                            ColorFiller.find((i) => i.key === "v3")?.value
                          }
                          type={"v3"}
                        />{" "}
                      </div>
                      <div className=" col-12 col-sm-6 mb-2 mb-sm-0">
                        {" "}
                        <PatternSelect
                          areaType={"v3"}
                          changeArea={setCheckPatternArea}
                          disabled={
                            (checkPatternArea !== "v3" &&
                              checkPatternArea !== "") ||
                            checkColorv3 !== ""
                              ? true
                              : false
                          }
                        />
                      </div>
                    </div>
                  ) : null
                 
                }
              </div>
            </div>
          ))}
        </OptionsWrapper>
      </CollapseDivWrapper>
      <SuitSizing />
      <FinalizeOrder />
    </div>
  );
}

export default LeftSide;

function SuitSizing() {
  let dispatch = useDispatch();
  let Fit = useSelector((state) => state.auth.fit);
  let Size = useSelector((state) => state.auth.size);

  return (
    <div className="mt-3">
      <CollapseDivWrapper title="Suit Sizing">
        <p>Select the Sizing of your suit</p>
        <OptionsWrapper className="OptionsWrapper">
          <div className="d-flex row p-2">
            <div className="col-3 col-sm-2 text-start">Fit</div>
            <div className="col-9 col-sm-10">
              <div class="row">
                <div className=" col-12 col-sm-6">
                  <Form.Select
                    value={Fit}
                    onChange={(e) => dispatch(setSizingFit(e.target.value))}
                  >
                    <option value="">Select Fit</option>
                    <option value="mens-fit-2">Men's Fit</option>
                    <option value="womens-fit-1">Women's Fit</option>
                  </Form.Select>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex row p-2">
            <div className="col-3 col-sm-2 text-start">Size</div>
            <div className="col-9 col-sm-10">
              <div class="row">
                <div className="col-12 col-sm-6">
                  <Form.Select
                    value={Size}
                    onChange={(e) => dispatch(setSizingSize(e.target.value))}
                  >
                    <option value="">Select Size</option>
                    <option value="xs-1">XS</option>
                    <option value="small-2">Small</option>
                    <option value="medium-3">Medium</option>
                    <option value="large-4">Large</option>
                    <option value="xl-5">XL</option>
                    <option value="xxl-6">XXL</option>
                  </Form.Select>
                </div>
              </div>
            </div>
          </div>
        </OptionsWrapper>
      </CollapseDivWrapper>
    </div>
  );
}

function FinalizeOrder() {
  let dispatch = useDispatch();
  const [confirmOrder, setConfirmOrder] = useState({
    confirm2: false,
    confirm3: false,
  });
  const [userName, setUserName] = useState("");
  const [fabricCanvasInstance, setFabricCanvasInstance] = useState("");
  let isAreaTowPatterns = useSelector((state) => state.auth.IsAreaTowPatterns);
  let isAreaThreePatterns = useSelector(
    (state) => state.auth.IsAreaThreePatterns
  );
  let grippper = useSelector((state) => state.auth.IsGripper);
  let pocket = useSelector((state) => state.auth.IsPocket);
  let IsCellPhoneZipperPocket = useSelector(
    (state) => state.auth.IsCellPhoneZipperPocket
  );
  let splitTorso = useSelector((state) => state.auth.IsSplitTorso);
  let ColorFiller = useSelector((state) => state.auth.SuitPartsList);
  var patterns = useSelector((state) => state.auth.PatternValue);
  var svgRef = useSelector((state) => state.auth.svgRef);
  let Fit = useSelector((state) => state.auth.fit);
  let Size = useSelector((state) => state.auth.size);
  let Loading = useSelector((state) => state.auth.isLoading);

  let contrastStiching = useSelector((state) => state.auth.IsContrastStiching);

  const canvasRef = React.useRef();

  useEffect(() => {
    if (canvasRef.current) {
      var canvas = new fabric.Canvas(canvasRef.current);
      setFabricCanvasInstance(canvas);
      dispatch(setglobalCanvas(canvas));
    }
  }, [canvasRef]);

  useEffect(() => {
    if (Loading === true) {
      addItemInCart();
    }
  }, [Loading]);

  const addItemInCart = () => {
    debugger;
    if (Fit === "" || Size === "") {
      alert("Please Select Suit Sizings");
      dispatch(setIsLoading(false));
      return false;
    }

    fabric.loadSVGFromString(svgRef.innerHTML, function (objects, options) {
      var obj = fabric.util.groupSVGElements(objects, options);
      debugger;
      obj
        .scaleToHeight(fabricCanvasInstance.height - 10)
        .set({
          left: 0,
          top: 0,
          width: fabricCanvasInstance.width + 20,
          backgroundColor: "yellow",
        })
        .setCoords();
      fabricCanvasInstance.add(obj).renderAll();

      let src = downloadImage();
      SendDesignViaMail(
        src,
        "",
        ColorFiller,
        contrastStiching,
        splitTorso,
        patterns,
        Fit,
        Size,
        grippper,
        pocket,
        IsCellPhoneZipperPocket,
        isAreaTowPatterns,
        isAreaThreePatterns,
        userName
      );
      uploadimageToWP(src);
    });
  };

  const downloadImage = () => {
    console.log("Downlaoding scan");
    let a = document.createElement("a");
    fabricCanvasInstance.setBackgroundColor(
      "rgba(255, 255, 255, 1)",
      fabricCanvasInstance.renderAll.bind(fabricCanvasInstance)
    );
    let dt = fabricCanvasInstance.toDataURL({
      format: "jpeg",
      quality: 1,
    });
    console.log(dt);
    dispatch(setdownloadImageSrc(dt));
    return dt;
  };

  const uploadimageToWP = (src) => {
    let config = {
      method: "POST",
      url: `${REACT_APP_BASE_URL}/wp-json/wp/v2/populateSuitValues`,
      data: {
        imgsrc: src,
        title: "jumpSuitProductImage_" + getCurrentDate(),
      },
    };
    axios(config)
      .then(function (response) {
        debugger;
        console.log(response.data);
        let fileurl = response.data.fileUrl;
        OriginalProduct(fileurl);
      })
      .catch(function (error) {
        console.log(error);
        dispatch(setIsLoading(false));
      });
  };

  const getCurrentDate = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = mm + "_" + dd + "_" + yyyy;
    return today;
  };

  const OriginalProduct = (imgURL) => {
    let config = {
      method: "GET",
      url: `${REACT_APP_BASE_URL}/wp-json/wc/v3/products/${ORIGINAL_PRODUCT_ID}`,
      headers: {
        Authorization: WC_BASIC_AUTH,
      },
    };
    axios(config)
      .then(function (response) {
        debugger;
        console.log(response.data);
        DuplicateProduct(response.data, imgURL);
      })
      .catch(function (error) {
        console.log(error);
        dispatch(setIsLoading(false));
      });
  };
  const DuplicateProduct = (data, imgURL) => {
    let prevData = data;
    debugger;
    let newData = {
      name: prevData.name + " - " + userName,
      type: prevData.type,
      regular_price: prevData.regular_price,
      description: prevData.description,
      short_description: prevData.short_description,
      categories: [],

      images: [
        {
          src: imgURL,
        },
      ],
    };

    let config = {
      method: "POST",
      url: `${REACT_APP_BASE_URL}/wp-json/wc/v3/products`,
      headers: {
        Authorization: WC_BASIC_AUTH,
        "Content-Type": "application/json",
      },
      data: newData,
    };
    axios(config)
      .then(function (response) {
        debugger;
        console.log(response.data);
        addAddOns(response.data, prevData);
      })
      .catch(function (error) {
        console.log(error);
        dispatch(setIsLoading(false));
      });
  };

  const addAddOns = (product, prevData) => {
    debugger;
    let newData = {
      meta_data: prevData.meta_data,
    };

    let config = {
      method: "POST",
      url: `${REACT_APP_BASE_URL}/wp-json/wc/v2/products/${product.id}`,
      headers: {
        Authorization: WC_BASIC_AUTH,
        "Content-Type": "application/json",
      },
      data: newData,
    };
    axios(config)
      .then(function (response) {
        debugger;
        console.log(response.data);
        let p_id = response.data.id;
        let link = response.data.permalink;
        let slug = response.data.slug;
        //send email here

        redirectToDestination(p_id, link, slug);
      })
      .catch(function (error) {
        console.log(error);
        dispatch(setIsLoading(false));
      });
  };

  const redirectToDestination = (id, link, slug) => {
    debugger;
    let Design = {
      p_id: id,
      p_name: slug,
      splitTorso: splitTorso,
      grippper: grippper,
      pocket: pocket,
      contrastStiching: contrastStiching,
      fit: Fit,
      size: Size,
      isCellPhoneZipperPocket: IsCellPhoneZipperPocket,
      area1: ColorsList.find(
        (x) => x.value === ColorFiller.find((i) => i.key === "v1").value
      )?.name,
      area2:
        isAreaTowPatterns === true
          ? patternOptions[patterns]
          : ColorsList.find(
              (x) => x.value === ColorFiller.find((i) => i.key === "v2").value
            )?.name,
      area3:
        isAreaThreePatterns === true
          ? patternOptions[patterns]
          : ColorsList.find(
              (x) => x.value === ColorFiller.find((i) => i.key === "v3").value
            )?.name,
      sublimation_Pattern:
        isAreaThreePatterns === true || isAreaTowPatterns === true
          ? "yes"
          : "no",
    };
    const searchParams = new URLSearchParams(Design);
    // window.location.href = link + '?' + searchParams.toString();
    var shortLink = document.createElement("a");
    shortLink.href = link + "?" + searchParams.toString();
    shortLink.target = "_parent";
    document.body.appendChild(shortLink);
    shortLink.click();
  };
  return (
    <div className="my-3">
      <CollapseDivWrapper title="Finalize Your Order">
        <h5 className="text-start mt-4 fw-bold">
          Order Subtotal: $
          {parseFloat(
            parseFloat(MAIN_PRICE) +
              (isAreaThreePatterns === true || isAreaTowPatterns === true
                ? parseFloat(PATTERN_PRICE)
                : parseFloat(0)) +
              (grippper === "yes" ? parseFloat(GRIPPER_PRICE) : parseFloat(0)) +
              (pocket === "yes" ? parseFloat(RDS_POCKET_PRICE) : parseFloat(0)) +
              (IsCellPhoneZipperPocket === "yes"
                ? parseFloat(CELL_PHONE_POCKET)
                : parseFloat(0))
          ).toFixed(2)}{" "}
          USD
        </h5>
        <div className="my-3">
          <Form.Check
            type="checkbox"
            value="yes"
            className="me-3 text-start form-check"
            id="confirm2"
          >
            <Form.Check.Input
              type="checkbox"
              value="yes"
              checked={confirmOrder.confirm2}
              onClick={(e) => {
                setConfirmOrder({
                  ...confirmOrder,
                  confirm2: e.target.checked,
                });
              }}
            />
            <Form.Check.Label>
              All custom sales orders are final and do not qualify for refunds
              or exchanges. <br />
              <u>
                No changes can be made to your order after the order is placed.
              </u>{" "}
              <br />
              By clicking this check box, you have read and agree to the{" "}
              <a target="_blank" href="https://kuasky.com/terms-of-service/">
                Terms of Service described here.
              </a>
            </Form.Check.Label>
          </Form.Check>
          <Form.Check
            type="checkbox"
            value="yes"
            className="me-3 text-start"
            id="confirm3"
            label={`I understand that actual fabric colors may differ from what is shown on this screen.`}
            checked={confirmOrder.confirm3}
            onClick={(e) => {
              setConfirmOrder({ ...confirmOrder, confirm3: e.target.checked });
            }}
          />
          <div className="form-group mt-3  text-start  align-items-center ">
            <label className="fw-normal me-2 mb-2 white-space-nowrap">
              Enter Your First and Last Name
            </label>
            <input
              type="text"
              className="form-control "
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
          </div>
        </div>
        <div className="text-end pt-2 ">
          <Button
            variant="primary"
            disabled={
              confirmOrder.confirm2 === true &&
              confirmOrder.confirm3 === true &&
              userName !== ""
                ? false
                : true
            }
            onClick={() => dispatch(setIsLoading(true))}
          >
            {" "}
            Create Order{" "}
          </Button>
        </div>
      </CollapseDivWrapper>
      <div className="myCanvasWrapper">
        <canvas id="myCanvas" ref={canvasRef} width={500} height={500}></canvas>
      </div>
    </div>
  );
}
